var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlantArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.3261,
    cy: 17.3262,
    r: 17.3262,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8436 22.9745C10.4531 23.3651 10.4531 23.9982 10.8436 24.3887C11.2341 24.7793 11.8673 24.7793 12.2578 24.3887L10.8436 22.9745ZM23.5272 12.7052C23.5272 12.1529 23.0795 11.7052 22.5272 11.7052L13.5272 11.7052C12.9749 11.7052 12.5272 12.1529 12.5272 12.7052C12.5272 13.2575 12.9749 13.7052 13.5272 13.7052L21.5272 13.7052L21.5272 21.7052C21.5272 22.2575 21.9749 22.7052 22.5272 22.7052C23.0795 22.7052 23.5272 22.2575 23.5272 21.7052L23.5272 12.7052ZM12.2578 24.3887L23.2343 13.4123L21.8201 11.9981L10.8436 22.9745L12.2578 24.3887Z",
    fill: "#11CB9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlantArrow);
export default __webpack_public_path__ + "static/media/slant-arrow.866a57f9af273d680b6dca9cd39c7146.svg";
export { ForwardRef as ReactComponent };